'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002412 from "./presto.-Presto$$anon$12.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00246 from "./presto.-Presto$$anon$6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00248 from "./presto.-Presto$$anon$8.js";
import * as $j_presto$002etypes$0024$002dCompact$002dApplication$0024 from "./presto.types$-Compact-Application$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$5() {
  this.bcH = null;
  this.bcz = null;
  this.bcA = false;
  this.bcI = null;
  this.bcJ = false;
  this.bcM = null;
  this.bcF = null;
  this.bcG = false;
  this.bcB = null;
  this.bcC = false;
  this.bcD = null;
  this.bcE = false;
  this.bcK = false;
  this.bcL = false;
  this.bcH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcM = "CompactApplication";
}
export { $c_Lpresto_Presto$$anon$5 as $c_Lpresto_Presto$$anon$5 };
$p = $c_Lpresto_Presto$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$5;
/** @constructor */
function $h_Lpresto_Presto$$anon$5() {
}
export { $h_Lpresto_Presto$$anon$5 as $h_Lpresto_Presto$$anon$5 };
$h_Lpresto_Presto$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bcH;
});
$p.M = (function() {
  if ((!this.bcA)) {
    this.bcz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcA = true;
  }
  return this.bcz;
});
$p.O = (function() {
  if ((!this.bcJ)) {
    this.bcI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bcJ = true;
  }
  return this.bcI;
});
$p.D = (function() {
  return this.bcM;
});
$p.t = (function() {
  if ((!this.bcG)) {
    this.bcF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("plans", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bcG = true;
  }
  return this.bcF;
});
$p.N = (function() {
  if ((!this.bcC)) {
    this.bcB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dPresto$0024$0024anon$00246.$c_Lpresto_Presto$$anon$6())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dPresto$0024$0024anon$00248.$c_Lpresto_Presto$$anon$8())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bcC = true;
  }
  return this.bcB;
});
$p.Q = (function() {
  if ((!this.bcE)) {
    this.bcD = new $j_presto$002e$002dPresto$0024$0024anon$002412.$c_Lpresto_Presto$$anon$12();
    this.bcE = true;
  }
  return this.bcD;
});
$p.v = (function() {
  if ((!this.bcL)) {
    this.bcK = false;
    this.bcL = true;
  }
  return this.bcK;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee78) => ((p) => \u03b4scrutinee78.adD(p)))($j_presto$002etypes$0024$002dCompact$002dApplication$0024.$m_Lpresto_types$CompactApplication$())));
});
var $d_Lpresto_Presto$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$5, "presto.Presto$$anon$5", ({
  No: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$5 as $d_Lpresto_Presto$$anon$5 };
//# sourceMappingURL=presto.-Presto$$anon$5.js.map
